import { lazy } from 'react';
import { suspend } from '../util/suspend';

export const Payout = suspend(lazy(() => import('./Payout')));
